import { RESET_DATASET } from 'store';

import { RESET_BOOTSTRAP_CIS } from '../types';
import { SET_PRIMARY_PARAMETER } from './types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_PRIMARY_PARAMETER:
      return action.primaryParameter;
    case RESET_DATASET:
    case RESET_BOOTSTRAP_CIS:
      return null;
    default:
      return state;
  }
};
